/* bold-notte — LA NOTTE DA FRANK (Halloween 2026).
   Lo caricano le sezioni della notte, e solo quando Liquid le stampa
   (dal 24 ottobre 00:00 al 31 ottobre 23:59, ora di Roma).

   Fa quattro cose:
     1. ricontrolla la scadenza sull'orologio di chi guarda: se la pagina
        arriva dalla cache dopo il 31, spegne la notte e rimette la home di sempre;
     2. la torcia dell'apertura (mouse; sul telefono va da sola o segue il dito)
        e le zucche che restano accese al buio;
     3. il conto alla rovescia;
     4. il bottone che copia il codice.

   Gira PRIMA di bold.js (sta più in alto nella pagina, ed è defer come lui):
   così, se la notte va spenta, bold.js trova già l'apertura di sempre.
   Niente librerie: solo requestAnimationFrame, e solo mentre l'apertura si vede. */
(function () {
  'use strict';
  if (window.__notteFrank) return;
  window.__notteFrank = true;

  var INIZIO_STD = 1792792800; /* 2026-10-24 00:00 Europe/Rome */
  var FINE_STD = 1793487600;   /* 2026-11-01 00:00 Europe/Rome */

  function tutti(sel, radice) { return Array.prototype.slice.call((radice || document).querySelectorAll(sel)); }
  function numero(v, riserva) { var n = parseInt(v, 10); return isFinite(n) ? n : riserva; }

  var segno = document.querySelector('[data-notte]');
  var INIZIO = numero(segno && segno.getAttribute('data-notte-inizio'), INIZIO_STD) * 1000;
  var FINE = numero(segno && segno.getAttribute('data-notte-fine'), FINE_STD) * 1000;
  var pigro = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. fuori dalla finestra: si torna alla home di sempre ---------- */
  function spegniSezioni() {
    tutti('[data-notte-sezione]').forEach(function (s) { s.hidden = true; });
  }
  function spegniApertura() {
    tutti('.ap--notte').forEach(function (sez) {
      sez.classList.remove('ap--notte');
      sez.setAttribute('data-testa', 'chiara');
      sez.removeAttribute('data-ap-colore');
      sez.removeAttribute('data-ap-regia');
      tutti('.notte-solo', sez).forEach(function (el) { el.parentNode.removeChild(el); });
      tutti('[data-notte-sempre]', sez).forEach(function (nastro) {
        var riga = nastro.getAttribute('data-notte-sempre');
        tutti('.ap__parola', nastro).forEach(function (p) { p.textContent = riga; });
      });
      var pannello = sez.querySelector('[data-ap-pannello]');
      if (pannello && !pannello.querySelector('.ap__foto')) pannello.classList.remove('ap__pannello--foto');
    });
  }
  var ora = Date.now();
  if (ora < INIZIO || ora >= FINE) {
    spegniSezioni();
    spegniApertura();
    return;
  }

  /* ---------- 2. l'apertura di notte ----------
     Primo schermo: la facciata vera di Corso Durante 74 con il titolo, la
     torcia calda (mouse; sul telefono deriva piano verso la porta e segue il
     dito) e i dettagli nascosti che si vedono solo sotto la luce.
     Allo scroll: la camera entra dalla porta, la luce del negozio riempie lo
     schermo, poi la coreografia di sempre (scheda, nastri, firma arancio).
     bold.js salta questa apertura: [data-ap-regia]. */
  tutti('.ap--notte[data-ap-regia]').forEach(apertura);

  function apertura(sez) {
    var scena = sez.querySelector('[data-ap-scena]');
    var pannello = sez.querySelector('[data-ap-pannello]');
    var camera = sez.querySelector('[data-nt-camera]');
    var foto = camera && camera.querySelector('.nt-foto');
    if (!scena || !pannello || !camera || !foto) return;
    var velo = sez.querySelector('[data-nt-velo]');
    var buio = sez.querySelector('[data-nt-torcia]');
    var calore = sez.querySelector('[data-nt-calore]');
    var lampo = sez.querySelector('[data-nt-lampo]');
    var vignetta = sez.querySelector('[data-nt-vignetta]');
    var titolo = sez.querySelector('[data-nt-titolo]');
    var dritta = sez.querySelector('[data-nt-dritta]');
    var firma = sez.querySelector('[data-ap-firma]');
    var entra = sez.querySelector('[data-nt-entra]');
    var boxDettagli = camera.querySelector('.nt-dettagli');
    var dettagli = tutti('[data-nt-dettaglio]', camera).map(function (el) {
      var parti = el.getAttribute('data-nt-dettaglio').split(';');
      return { el: el, largo: parti[0].split(',').map(parseFloat), tel: (parti[1] || parti[0]).split(',').map(parseFloat), cx: 0, cy: 0, o: -1 };
    });

    var mouse = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var W = 1, H = 1, R = 300, zoom = 3;
    var porta = { x: 0, y: 0 };
    var luce = { x: 0, y: 0 };
    var dito = { x: 0, y: 0, quando: -1e9, attivo: false };
    var visibile = true, giro = null, t0 = 0, progresso = 0;
    var ATTESA_DITO = 2600;

    /* la barra del codice (snippet soleo-halloween) spinge giù la scena: il titolo
       deve restare nel primo schermo anche sul telefono */
    function barra() {
      var b = document.getElementById('soleo-halloween');
      sez.style.setProperty('--nt-barra', (b ? b.offsetHeight : 0) + 'px');
    }

    function telefono() { return window.matchMedia('(max-width: 749px)').matches; }

    /* dove cade un punto della foto (0-1) nel pannello, rifacendo object-fit: cover */
    function copertura() {
      var iw = foto.naturalWidth, ih = foto.naturalHeight;
      if (!iw || !ih) return null;
      var s = Math.max(W / iw, H / ih), dw = iw * s, dh = ih * s;
      var pos = (window.getComputedStyle(foto).objectPosition || '50% 50%').split(' ');
      var px = (parseFloat(pos[0]) || 50) / 100, py = (parseFloat(pos[1]) || 50) / 100;
      return { ox: (W - dw) * px, oy: (H - dh) * py, dw: dw, dh: dh };
    }

    function misura() {
      W = pannello.offsetWidth || 1;
      H = pannello.offsetHeight || 1;
      barra();
      R = mouse ? Math.min(440, Math.max(280, W * 0.24)) : Math.min(250, Math.max(170, W * 0.56));
      pannello.style.setProperty('--nt-r', Math.round(R) + 'px');
      var c = copertura();
      var tel = telefono() && camera.hasAttribute('data-nt-porta-tel');
      var p = ((tel ? camera.getAttribute('data-nt-porta-tel') : camera.getAttribute('data-nt-porta')) || '').split(',').map(parseFloat);
      var px = isFinite(p[0]) ? p[0] : 0.5, py = isFinite(p[1]) ? p[1] : 0.5, pw = isFinite(p[2]) ? p[2] : 0.2;
      if (c) {
        porta.x = c.ox + px * c.dw;
        porta.y = c.oy + py * c.dh;
        zoom = Math.min(5.5, Math.max(1.8, (W / (pw * c.dw)) * 0.92));
        dettagli.forEach(function (d) {
          var v = tel ? d.tel : d.largo;
          var l = c.ox + v[0] * c.dw, t = c.oy + v[1] * c.dh, w = v[2] * c.dw;
          d.el.style.width = w.toFixed(1) + 'px';
          d.el.style.transform = 'translate3d(' + l.toFixed(1) + 'px,' + t.toFixed(1) + 'px,0)';
          d.cx = l + w / 2;
          d.cy = t + (d.el.offsetHeight || w) / 2;
        });
      } else {
        porta.x = W * px; porta.y = H * py;
      }
      camera.style.transformOrigin = porta.x.toFixed(1) + 'px ' + porta.y.toFixed(1) + 'px';
      /* la torcia parte dalla porta: il velo e la luce hanno il centro lì */
      [velo, calore].forEach(function (el) {
        if (!el) return;
        el.style.left = (porta.x - W).toFixed(1) + 'px';
        el.style.top = (porta.y - H).toFixed(1) + 'px';
      });
    }

    misura();
    luce.x = porta.x; luce.y = porta.y;
    if (!foto.complete) {
      foto.addEventListener('load', function () {
        misura();
        if (window.ScrollTrigger) window.ScrollTrigger.refresh();
      }, { once: true });
    }
    var attesaMisura = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(attesaMisura);
      attesaMisura = window.setTimeout(misura, 150);
    }, { passive: true });

    /* chi ha chiesto meno movimento: foto ferma, luce sulla porta, titolo; niente regia */
    if (pigro) { rivela(luce.x, luce.y); return; }

    function rivela(x, y) {
      dettagli.forEach(function (d) {
        var dist = Math.sqrt((d.cx - x) * (d.cx - x) + (d.cy - y) * (d.cy - y));
        var o = Math.max(0, Math.min(1, (R * 0.82 - dist) / (R * 0.42)));
        if (Math.abs(o - d.o) > 0.02) { d.o = o; d.el.style.opacity = o.toFixed(2); }
      });
    }

    function segna(x, y) { dito.x = x; dito.y = y; dito.quando = performance.now(); dito.attivo = true; }
    if (mouse) {
      window.addEventListener('mousemove', function (e) { segna(e.clientX, e.clientY); }, { passive: true });
      document.documentElement.addEventListener('mouseleave', function () { dito.attivo = false; });
    } else {
      var tocco = function (e) { var t = e.touches && e.touches[0]; if (t) segna(t.clientX, t.clientY); };
      pannello.addEventListener('touchstart', tocco, { passive: true });
      pannello.addEventListener('touchmove', tocco, { passive: true });
    }

    function frame(t) {
      giro = null;
      if (!visibile || document.hidden) return;
      if (!t0) t0 = t;
      var u = (t - t0) / 1000;
      if (progresso < 0.14) {
        var r = pannello.getBoundingClientRect();
        var k = r.width ? W / r.width : 1;
        var usaDito = dito.attivo && (mouse || t - dito.quando < ATTESA_DITO);
        var tx, ty;
        if (usaDito) {
          tx = Math.min(W, Math.max(0, (dito.x - r.left) * k));
          ty = Math.min(H, Math.max(0, (dito.y - r.top) * k));
          if (dritta && !dritta.classList.contains('is-via')) dritta.classList.add('is-via');
        } else {
          /* da sola: deriva lenta attorno alla porta, sulla strada e sulla facciata */
          tx = porta.x + W * (mouse ? 0.22 : 0.17) * Math.sin(u * (mouse ? 0.42 : 0.33));
          ty = porta.y + H * (mouse ? 0.15 : 0.11) * Math.sin(u * 0.55 + 1.2);
        }
        var morbido = usaDito ? 0.16 : 0.045;
        luce.x += (tx - luce.x) * morbido;
        luce.y += (ty - luce.y) * morbido;
        /* il tremolio della fiamma: tre seni fuori passo, mai un ritmo riconoscibile */
        var fiamma = 1 + 0.028 * Math.sin(u * 11.3) + 0.018 * Math.sin(u * 23.7 + 0.6) + 0.01 * Math.sin(u * 41.9 + 2.1);
        var sposta = 'translate3d(' + (luce.x - porta.x).toFixed(1) + 'px,' + (luce.y - porta.y).toFixed(1) + 'px,0)';
        if (velo) velo.style.transform = sposta;
        if (calore) {
          calore.style.transform = sposta + ' scale(' + fiamma.toFixed(3) + ')';
          calore.style.opacity = (0.86 + 0.14 * Math.sin(u * 17.1 + Math.sin(u * 5.3))).toFixed(3);
        }
        rivela(luce.x, luce.y);
        if (dritta && window.scrollY > 80) dritta.classList.add('is-via');
      }
      giro = window.requestAnimationFrame(frame);
    }
    function avvia() { if (!giro && visibile && !document.hidden) giro = window.requestAnimationFrame(frame); }
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (voci) { visibile = voci[0].isIntersecting; avvia(); }).observe(scena);
    }
    document.addEventListener('visibilitychange', avvia);
    avvia();

    /* la regia allo scroll: si entra dal negozio, poi scheda, nastri e firma */
    var haGsap = typeof window.gsap !== 'undefined' && typeof window.ScrollTrigger !== 'undefined';
    if (!haGsap) return;
    gsap.registerPlugin(ScrollTrigger);
    var tratti = firma ? tutti('path, text', firma) : [];
    tratti.forEach(function (t) { gsap.set(t, { strokeDasharray: 1500, strokeDashoffset: 1500 }); });

    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: sez, start: 'top top', end: 'bottom bottom',
        pin: scena, scrub: 0.7, anticipatePin: 1, invalidateOnRefresh: true,
        onUpdate: function (st) { progresso = st.progress; },
        onRefreshInit: misura
      }
    });
    /* l'entrata del titolo sta sui figli: il contenitore lo comanda la timeline */
    if (titolo) gsap.from(titolo.children, { opacity: 0, y: 26, duration: 0.9, ease: 'expo.out', stagger: 0.08, delay: 0.15 });
    var luci = [buio, calore, boxDettagli, dritta].filter(Boolean);
    if (titolo) tl.to(titolo, { autoAlpha: 0, y: -50, duration: 0.07, ease: 'power1.in' }, 0);
    tl.to(luci, { opacity: 0, duration: 0.1, ease: 'none' }, 0.02);
    if (vignetta) tl.to(vignetta, { opacity: 0, duration: 0.18, ease: 'none' }, 0.06);
    tl.fromTo(camera, { scale: 1 }, { scale: function () { return zoom; }, duration: 0.3, ease: 'power2.in' }, 0.04);
    if (lampo) {
      tl.to(lampo, { opacity: 0.9, duration: 0.08, ease: 'power1.in' }, 0.27)
        .to(lampo, { opacity: 0, duration: 0.12, ease: 'power1.out' }, 0.36);
    }
    tl.to(camera, { scale: function () { return zoom * 1.15; }, duration: 0.2, ease: 'none' }, 0.34)
      .to(pannello, { scale: 0.30, borderRadius: 20, duration: 0.26, ease: 'power2.inOut' }, 0.46);
    if (tratti.length) {
      tl.to(tratti, { strokeDashoffset: 0, ease: 'none', duration: 0.2, stagger: 0.02 }, 0.6)
        .to(tratti, { fillOpacity: 1, duration: 0.08, ease: 'power1.out' }, 0.8);
    }
    tl.to([pannello, firma].filter(Boolean), { yPercent: -16, opacity: 0, duration: 0.1, ease: 'power2.in' }, 0.9);

    /* «Entra»: fa la strada dentro il negozio, poi si ferma dove inizia la pagina */
    if (entra) {
      entra.addEventListener('click', function (e) {
        if (!window.__lenis) return;
        e.preventDefault();
        var fine = sez.getBoundingClientRect().top + window.scrollY + sez.offsetHeight - window.innerHeight + 2;
        window.__lenis.scrollTo(fine, { duration: 3.4, easing: function (x) { return 1 - Math.pow(1 - x, 3); } });
      });
    }
  }

  /* il conto breve del primo schermo: 7g 06h 12m */
  tutti('[data-nt-breve-testo]').forEach(function (el) {
    function batti() {
      var resto = Math.max(0, Math.floor((FINE - Date.now()) / 1000));
      el.textContent = Math.floor(resto / 86400) + 'g ' + due(Math.floor((resto % 86400) / 3600)) + 'h ' + due(Math.floor((resto % 3600) / 60)) + 'm';
      if (resto > 0) window.setTimeout(batti, 20000);
    }
    batti();
  });

  /* ---------- 3. il conto alla rovescia ---------- */
  function due(n) { return (n < 10 ? '0' : '') + n; }
  tutti('[data-nt-conto]').forEach(function (conto) {
    var g = conto.querySelector('[data-nt-g]'), o = conto.querySelector('[data-nt-o]');
    var m = conto.querySelector('[data-nt-m]'), s = conto.querySelector('[data-nt-s]');
    function batti() {
      var resto = Math.max(0, Math.floor((FINE - Date.now()) / 1000));
      if (g) g.textContent = due(Math.floor(resto / 86400));
      if (o) o.textContent = due(Math.floor((resto % 86400) / 3600));
      if (m) m.textContent = due(Math.floor((resto % 3600) / 60));
      if (s) s.textContent = due(resto % 60);
      if (resto <= 0) { spegniSezioni(); return; }
      window.setTimeout(batti, 1000 - (Date.now() % 1000) + 8);
    }
    batti();
  });

  /* ---------- 4. copia il codice ---------- */
  tutti('[data-nt-copia]').forEach(function (bottone) {
    var codice = bottone.getAttribute('data-nt-copia');
    var testo = bottone.querySelector('[data-nt-copia-testo]');
    var biglietto = bottone.closest('.ntc__biglietto');
    var esito = biglietto && biglietto.querySelector('[data-nt-esito]');
    var originale = testo ? testo.textContent : '';
    var attesa = null;

    function dici(frase, riuscito) {
      if (esito) esito.textContent = frase;
      if (testo) testo.textContent = riuscito ? 'Copiato' : originale;
      bottone.classList.toggle('is-fatto', !!riuscito);
      window.clearTimeout(attesa);
      attesa = window.setTimeout(function () {
        if (testo) testo.textContent = originale;
        bottone.classList.remove('is-fatto');
      }, 2600);
    }
    function aMano() {
      /* il vecchio modo, per i browser senza appunti: si seleziona il codice */
      var campo = document.createElement('textarea');
      campo.value = codice;
      campo.setAttribute('readonly', '');
      campo.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none';
      document.body.appendChild(campo);
      campo.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      document.body.removeChild(campo);
      if (ok) dici('Fatto: ' + codice + ' è negli appunti. Incollalo in cassa.', true);
      else dici('Non sono riuscito a copiarlo: scrivi ' + codice + ' in cassa, oppure usa «Usalo subito».', false);
    }
    bottone.addEventListener('click', function () {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(codice).then(function () {
          dici('Fatto: ' + codice + ' è negli appunti. Incollalo in cassa.', true);
        }, aMano);
      } else {
        aMano();
      }
    });
  });
})();
